import(/* webpackMode: "eager" */ "/vercel/path0/app/(global)/blog-evenements/[slug]/page.tsx");
